// @flow

import { requestTypeCreator } from 'src/helpers'

import type {
  BasicRedux,
  SetUserError,
  SetUserRequest,
  SetUserResponse,
  RegisterUserRequest,
  RegisterUserActionTypes,
  SetUserActionTypes,
  SendActivationEmailRequest,
  SendActivationEmailActionTypes,
  EditUserActionTypes,
  SetUserPasswordTypes,
  SubmitUserAgreementTypes,
  EditUserPasswordTypes,
} from './userTypes'

export const GET_USER = requestTypeCreator('GET_USER')

export const SET_USER = requestTypeCreator('SET_USER')
export const SET_USER_BY_SESSION = requestTypeCreator('SET_USER_BY_SESSION')
export const REGISTER_USER = requestTypeCreator('REGISTER_USER')

export const RESET_USER = 'RESET_USER'
export const LOGOUT_USER = requestTypeCreator('LOGOUT_USER')
export const SEND_ACTIVATION_EMAIL = requestTypeCreator('SEND_ACTIVATION_EMAIL')
export const EDIT_USER = requestTypeCreator('EDIT_USER')

export const SET_USER_PASSWORD = requestTypeCreator('SET_USER_PASSWORD')
export const EDIT_USER_PASSWORD = requestTypeCreator('EDIT_USER_PASSWORD')
export const EDIT_USER_EMAIL = requestTypeCreator('EDIT_USER_EMAIL')
export const SUBMIT_USER_AGREEMENT = requestTypeCreator('SUBMIT_USER_AGREEMENT')
export const EDIT_USER_GEOLOCATION_ZIP = 'EDIT_USER_GEOLOCATION_ZIP'

export const setUser = {
  error: (payload: SetUserError): SetUserActionTypes => ({ type: SET_USER.FAILURE, payload }),
  request: (payload: SetUserRequest): SetUserActionTypes => ({ type: SET_USER.REQUEST, payload }),
  success: (payload: SetUserResponse): SetUserActionTypes => ({ type: SET_USER.SUCCESS, payload }),
}

export const setUserBySession = {
  error: (payload: SetUserError): SetUserActionTypes => ({ type: SET_USER_BY_SESSION.FAILURE, payload }),
  request: (payload: SetUserRequest): SetUserActionTypes => ({ type: SET_USER_BY_SESSION.REQUEST, payload }),
  success: (payload: SetUserResponse): SetUserActionTypes => ({ type: SET_USER_BY_SESSION.SUCCESS, payload }),
}

export const getUser = {
  error: (payload: any): BasicRedux => ({ type: GET_USER.FAILURE, payload }),
  request: (payload: any): BasicRedux => ({ type: GET_USER.REQUEST, payload }),
  success: (payload: any): BasicRedux => ({ type: GET_USER.SUCCESS, payload }),
}

export const registerUser = {
  error: (payload: SetUserError): RegisterUserActionTypes => ({ type: REGISTER_USER.FAILURE, payload }),
  request: (payload: RegisterUserRequest): RegisterUserActionTypes => ({ type: REGISTER_USER.REQUEST, payload }),
  success: (payload: SetUserResponse): RegisterUserActionTypes => ({ type: REGISTER_USER.SUCCESS, payload }),
}

export const resetUser = {
  success: () => ({ type: RESET_USER }),
}

export const sendActivationEmail = {
  error: (payload: any): SendActivationEmailActionTypes => ({ type: SEND_ACTIVATION_EMAIL.FAILURE, payload }),
  request: (payload: SendActivationEmailRequest): SendActivationEmailActionTypes => ({ type: SEND_ACTIVATION_EMAIL.REQUEST, payload }),
  success: (payload: any): SendActivationEmailActionTypes => ({ type: SEND_ACTIVATION_EMAIL.SUCCESS, payload }),
}

export const editUser = {
  error: (payload: SetUserError): EditUserActionTypes => ({ type: EDIT_USER.FAILURE, payload }),
  request: (payload: any): EditUserActionTypes => ({ type: EDIT_USER.REQUEST, payload }),
  success: (payload: any): EditUserActionTypes => ({ type: EDIT_USER.SUCCESS, payload }),
}

export const setUserPassword = {
  error: (payload: any): SetUserPasswordTypes => ({ type: SET_USER_PASSWORD.FAILURE, payload }),
  request: (payload: any): SetUserPasswordTypes => ({ type: SET_USER_PASSWORD.REQUEST, payload }),
  success: (payload: any): SetUserPasswordTypes => ({ type: SET_USER_PASSWORD.SUCCESS, payload }),
}

export const editUserPassword = {
  error: (payload: any): EditUserPasswordTypes => ({ type: EDIT_USER_PASSWORD.FAILURE, payload }),
  request: (payload: any): EditUserPasswordTypes => ({ type: EDIT_USER_PASSWORD.REQUEST, payload }),
  success: (payload: any): EditUserPasswordTypes => ({ type: EDIT_USER_PASSWORD.SUCCESS, payload }),
}

export const logout = {
  error: (payload: any): BasicRedux => ({ type: LOGOUT_USER.FAILURE, payload }),
  request: (payload: any): BasicRedux => ({ type: LOGOUT_USER.REQUEST, payload }),
  success: (payload: any): BasicRedux => ({ type: LOGOUT_USER.SUCCESS, payload }),
}

export const editUserEmail = {
  error: (payload: any): BasicRedux => ({ type: EDIT_USER_EMAIL.FAILURE, payload }),
  request: (payload: any): BasicRedux => ({ type: EDIT_USER_EMAIL.REQUEST, payload }),
  success: (payload: any): BasicRedux => ({ type: EDIT_USER_EMAIL.SUCCESS, payload }),
}

export const submitUserAgreement = {
  error: (payload: any): SubmitUserAgreementTypes => ({ type: SUBMIT_USER_AGREEMENT.FAILURE, payload }),
  request: (payload: any): SubmitUserAgreementTypes => ({ type: SUBMIT_USER_AGREEMENT.REQUEST, payload }),
  success: (payload: any): SubmitUserAgreementTypes => ({ type: SUBMIT_USER_AGREEMENT.SUCCESS, payload }),
}

export const editUserGeoLocationZip = {
  success: (payload: any): EditUserActionTypes => ({ type: EDIT_USER_GEOLOCATION_ZIP, payload }),
}

